import { memo, useCallback, useRef } from "react"
import { AptModal, AptModalBackdrop } from "./ApartmentCard.style"
import FavouriteCard from "../../FavouriteCard/FavouriteCard"
import { useStore } from "../../../state/store"

function ApartmentCard({ id }) {
  let activeApt = useStore(useCallback(state => state.activeApt, []))
  const setActiveApt = useStore(useCallback(state => state.setActiveApt, []))
  const ref = useRef()
  if (activeApt) {
    return (
      <>
        <AptModalBackdrop onClick={() => setActiveApt(null)} opacity={activeApt} />
        <AptModal ref={ref} opacity={activeApt}>
          <FavouriteCard id={activeApt} />
        </AptModal>
      </>
    )
  } else return null
}
export default memo(ApartmentCard)
